import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BtnComponent} from './button.component';
import {MatButtonModule} from '@angular/material/button';
import {RadioButtonComponent} from './radio-button/radio-button.component';
import {ProgressSpinnerModule} from '../progress-spinner/progress-spinner.module';

@NgModule({
  declarations: [BtnComponent, RadioButtonComponent],
  exports: [BtnComponent, RadioButtonComponent],
  imports: [CommonModule, MatButtonModule, ProgressSpinnerModule],
})
export class ButtonModule {}
